import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@stashinvest/ui';

export const CustodialIcon = () => {
	const { colors } = useTheme();
	return (
		<svg
			width="26px"
			height="26px"
			viewBox="0 0 405 360"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill="none" fillRule="evenodd">
				<path
					d="M81.616 152.8C30.662 165.105 0 188.062 0 225.305c0 8.612 1.64 17.456 4.79 26.298 24.973 15.189 65.395 40.543 129.338 57.146 78.785-5.234 184.078-22.072 270.249-73.607.413-3.289.623-6.571.623-9.837 0-38.294-28.82-60.803-77.656-72.727C317.379 76.586 254.337 0 204.494 0 154.604 0 91.487 76.735 81.616 152.8zm-1.237 26.077C57.64 187.84 42.96 199.815 42.96 214.442c0 18.328 23.05 32.492 56.12 41.785-11.194-22.132-17.876-48.452-18.701-77.35zm228.522 76.61c31.682-9.298 53.539-23.197 53.539-41.045 0-13.853-13.168-25.327-33.877-34.117-.918 25.916-6.556 49.723-15.936 70.251a69.207 69.207 0 0 1-3.726 4.91zM24.78 285.954c7.154 8.734 15.748 17.135 25.641 24.942 8.495.087 18.483.122 29.699-.029-19.82-7.165-38.29-15.51-55.34-24.913zm284.533 53.434C279.532 352.184 243.85 360 203.794 360c-55.773 0-103.623-15.734-138.914-38.734 14.936-.434 29.083-.933 42.552-1.528 57.776 16.742 125.538 24.146 201.882 19.651zm-177.547-79.457c-17.748-20.23-28.534-49.676-28.534-87.148 0-70.506 61.196-149.981 101.261-149.981s101.262 79.475 101.262 149.981c0 36.762-10.382 65.8-27.533 85.987-6.101 5.293-44.363 10.23-73.729 10.23-28.834 0-70.128-4.243-72.727-9.07zm108.3-151.021c-6.724-7.027-14.655-12.511-25.69-14.053v-17.31h-16.724V95.2c-16.207 3.257-26.207 14.91-26.207 31.705 0 30.848 45.518 30.505 45.518 48.157 0 7.883-4.31 11.825-13.966 11.825-8.276 0-15.862-3.428-24.655-9.94l-11.034 16.966c8.103 7.37 20.172 11.825 30.344 13.025v17.137h16.724v-17.823c17.759-3.77 26.897-16.452 26.897-32.904 0-32.733-45.517-31.362-45.517-47.643 0-7.712 4.482-10.968 12.758-10.968 7.242 0 12.586 2.914 18.793 8.57l12.759-14.396z"
					fill={colors.iconDefault}
					fillRule="nonzero"
				/>
				<path
					d="M308.187 289.9c16.707 4.69 35.812 9.258 57.314 13.705-6.871 6.366-14.563 12.398-23.015 17.984-70.65 6.78-128.362 3.157-175.406-5.542 54.183-4.56 97.438-12.254 141.107-26.147zm22.718-7.768c22.074-8.063 44.741-17.808 69.419-29.618-4.848 14.254-13.369 28.292-25.116 41.28-16.203-3.64-30.97-7.527-44.303-11.662z"
					fill={colors.iconDefault}
				/>
				<path
					d="M308.9 255.486c31.683-9.297 53.54-23.196 53.54-41.044 0-13.853-13.168-25.327-33.877-34.117-.918 25.916-6.556 49.723-15.936 70.251a69.207 69.207 0 0 1-3.726 4.91zM80.379 178.877C57.64 187.84 42.96 199.815 42.96 214.442c0 18.328 23.05 32.492 56.12 41.785-11.194-22.132-17.876-48.452-18.701-77.35z"
					fill="#FFF"
				/>
				<path
					d="M240.067 108.91c-6.724-7.026-14.655-12.51-25.69-14.052v-17.31h-16.724V95.2c-16.207 3.257-26.207 14.91-26.207 31.705 0 30.848 45.518 30.505 45.518 48.157 0 7.883-4.31 11.825-13.966 11.825-8.276 0-15.862-3.428-24.655-9.94l-11.034 16.966c8.103 7.37 20.172 11.825 30.344 13.025v17.137h16.724v-17.823c17.759-3.77 26.897-16.452 26.897-32.904 0-32.733-45.517-31.362-45.517-47.643 0-7.712 4.482-10.968 12.758-10.968 7.242 0 12.586 2.914 18.793 8.57l12.759-14.396z"
					fill={colors.iconDefault}
				/>
			</g>
		</svg>
	);
};

CustodialIcon.propTypes = {
	color: PropTypes.string,
};

export default CustodialIcon;
